<template>
  <div :style="componentStyle">
    <sign-document v-if="isSignDocumentSelected" :toggle-tab="toggleTab"></sign-document>
    <sign v-if="isSignSelected" :toggle-tab="toggleTab"></sign>
    <signFirel v-if="isSignSelectedFirel" :toggle-tab="toggleTab"></signFirel>
    <success v-if="isSuccess" :toggle-tab="toggleTab" :redirect-url="redirectUrl" />
    <DocumentNotAvailable v-if="isDocumentNotAvailable" :toggle-tab="toggleTab"/>
    <SignatureRejected v-if="isSignatureRejected" :toggle-tab="toggleTab"/>
    <SignedDocument v-if="isSignedDocument" :toggle-tab="toggleTab" :redirect-url="redirectUrl"/>
    <isSigning v-if="isSigning" :toggle-tab="toggleTab"/>
    <sign-simple v-if="isSignSimple" :toggle-tab="toggleTab" />
    <sign-super-simple v-if="isSignSuperSimple" :toggle-tab="toggleTab" />
  </div>
</template>

<script>
import SignDocument from "@/views/pages/sign-document/components/SignDocument";
import Sign from "@/views/pages/sign-document/components/Sign";
import SignFirel from "@/views/pages/sign-document/components/SignFirel";
import Success from "@/views/pages/sign-document/components/Success";
import DocumentNotAvailable from "@/views/pages/sign-document/components/DocumentNotAvailable";
import SignatureRejected from "@/views/pages/sign-document/components/SignatureRejected";
import SignedDocument from "@/views/pages/sign-document/components/SignedDocument";
import isSigning from "@/views/pages/sign-document/components/isSigning";
import SignSimple from "@/views/pages/sign-document/components/SignSimple.vue";
import SignSuperSimple from "./components/SignSuperSimple.vue";
import router from "../../../router";
export default {
  name: "SignDocumentPage",
  components: {
    SignDocument,
    Sign,
    SignFirel,
    isSigning,
    Success,
    DocumentNotAvailable,
    SignatureRejected,
    SignedDocument,
    SignSimple,
    SignSuperSimple
  },
  data() {
    return {
      tabIndex: 1,
      uuid: '',
      redirectUrl: null,
      config: {
        primaryColor: "69,20,199",
        secondaryColor: "90,123,177"
      }
    }
  },
  computed: {
    isSignDocumentSelected() {
      return this.tabIndex === 1;
    },

    isSignSelected() {
      return this.tabIndex === 2;
    },

    isSuccess() {
      return this.tabIndex === 3;
    },

    isDocumentNotAvailable() {
      return this.tabIndex === 4;
    },

    isSignatureRejected() {
      return this.tabIndex === 5;
    },
    isSignedDocument() {
      return this.tabIndex === 6;
    },
    isSigning() {
      return this.tabIndex === 7;
    },
    isSignSelectedFirel() {
      return this.tabIndex === 8;
    },
    isSignSimple() {
      return this.tabIndex === 9;
    },
    isSignSuperSimple() {
      return this.tabIndex === 10;
    },
    componentStyle() {
      return {
        "--vs-primary": this.config.primaryColor,
        "--vs-secondary": this.config.secondaryColor
      };
    }
  },
  methods: {
    toggleTab(index, redirectUrl = null) {
      this.tabIndex = index;
      this.redirectUrl = redirectUrl;
      this.scrollToTop();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    updated() {
      this.scrollToTop();
    },
    hexToRgb(hex) {
      hex = hex.replace(/^#/, '');

      if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
      }

      if (hex.length !== 6) {
        throw new Error('El valor hexadecimal proporcionado es inválido.');
      }

      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      return `${r},${g},${b}`;
    }
  },
  created() {
    let uuid = this.$route.params.uuid;
    if (uuid) {
      this.uuid = uuid;
      this.$store.dispatch("document/getDocumentFromSignature", {uuid: uuid}).then(
        document => {
          if (document.attributes.config.primary_color) {
            this.config.primaryColor = this.hexToRgb(document.attributes.config.primary_color);
          }
          if (document.attributes.config.secondary_color) {
            this.config.secondaryColor = this.hexToRgb(document.attributes.config.secondary_color);
          }
        }
      )
    } else {
      router.push("/");
    }
  }
}
</script>

<style scoped>

</style>
